import React from "react";
import PropTypes from "prop-types";
import { isBlueprintGenerating, isBlueprintGenerationFailed } from "constants/index";
import { colors } from "style";
import { Spinner } from "components/Loader";
import Icon, { ICON_SIZE, ICON_TYPE } from "components/Icon";
import Tooltip from "components/Tooltip";

/**
 * BlueprintGenerationIndicator
 *
 * A spinner while the agent is generating a blueprint, or a warning once it failed. Renders nothing otherwise.
 *
 * @param {Object}  template  The blueprint, with its latestBlueprintGenerationAgentTask
 */
const BlueprintGenerationIndicator = ({ template }) => {
  if (isBlueprintGenerating(template)) {
    return (
      <Tooltip tooltipId="Blueprints.List.Generating" hideIcon>
        <Spinner size="1.6rem" margin="0" />
      </Tooltip>
    );
  }

  if (isBlueprintGenerationFailed(template)) {
    return (
      <Tooltip tooltipId="Blueprints.List.GenerationFailed" hideIcon>
        <Icon type={ICON_TYPE.circleWarning} size={ICON_SIZE.small} color={colors.error} />
      </Tooltip>
    );
  }

  return null;
};

BlueprintGenerationIndicator.propTypes = {
  template: PropTypes.shape({
    latestBlueprintGenerationAgentTask: PropTypes.shape({
      state: PropTypes.string,
    }),
  }),
};

export default BlueprintGenerationIndicator;
